<template>
<section class="order-saving">
    <span class="order-saving__title">쿠폰 사용</span>
    <div class="order-saving__contents">
        <div class="order-saving__block">
            <span class="order-saving__subtitle">배송비 할인쿠폰 사용</span>
            <div class="order-saving__form">
                <div class="input input--red"><input :value="totalCouponAmount.format()" disabled readonly><span class="currency-unit">원</span></div>
                <button class="button button--mouse" type="button" @click="$refs.modal.open()"><span>쿠폰사용</span></button>
                <span class="left-text">사용가능 쿠폰 : {{ coupons.length }}장</span>
            </div>
        </div>
    </div>
    <modal-delivery-coupons ref="modal" v-model="deliveryCoupons" :coupons="coupons" :carts="carts" :shippings="shippings" :islands="islands" :postcode="postcode"  @input="$emit('input', deliveryCoupons)" @totalCouponAmount="(amount) => (totalCouponAmount = amount)"></modal-delivery-coupons>
</section>
</template>

<script>
import ModalDeliveryCoupons from "@/components/client/shop/modal-delivery-coupons.vue";

export default {
    components: {
        ModalDeliveryCoupons
    },
    props: {
        value: { type: Array, default: null },
        coupons: { type: Array, default: null },
        carts: { type: Array, default: null },
        shippings: { type: Array, default: null },
        islands: { type: Array, default: null },
        postcode: { type: String, default: null },
    },
    data() {
        return {
            deliveryCoupons: this.$props.value || [],
            totalCouponAmount: 0,
        };
    },
    methods: {
        open() {},
        close() {},
    },
    watch: {
        totalCouponAmount() {
            this.$emit("deliveryCouponAmount", this.totalCouponAmount);
        },
    },
}
</script>